import React from 'react';
import {
  useField,
} from 'formik';

import FieldsSingleSelect from './FieldsSingleSelect.jsx';
import FieldsMultiSelect from './FieldsMultiSelect.jsx';
import FieldsOrdering from './FieldsOrdering.jsx';
import FieldsMatching from './FieldsMatching.jsx';

const FieldsQtnOpts = ({
  qtnIndex: i,
  restrictEdit,
  fileUploadUrl,
}) => {
  const [, { value }] = useField(`questions.${i}`);
  const { format = 'single-select' } = value;
  let Options = FieldsSingleSelect; // default format

  if (format === 'multi-select') Options = FieldsMultiSelect;
  if (format === 'ordering') Options = FieldsOrdering;
  if (format === 'matching') Options = FieldsMatching;

  return (
    <Options
      qtnIndex={i}
      restrictEdit={restrictEdit}
      fileUploadUrl={fileUploadUrl}
    />
  );
};

export default FieldsQtnOpts;
